import React from "react";

/**
 * `booking_slot_creatives.status` — the creative's own DESIGN status (see
 * order_booking constants CREATIVE_STATUS). Shared between
 * `BookingCreativesAssign.js` (table/cards) and the `ContentWriter/OrderBooking/
 * admin` `DetailDrawer.js` (Info tab), which is why it lives in this dedicated
 * module rather than being exported straight from `BookingCreativesAssign.js`
 * — that file already imports `DetailDrawer.js`, so the reverse import would
 * create a circular dependency.
 *
 * This is a DIFFERENT status model from the content-writer workflow status
 * (`row.content_status`, admin `config.js`'s `STATUS`/`getStatus`/`StatusPill`)
 * — do not conflate the two.
 */
export const CREATIVE_STATUS = Object.freeze({
  DRAFT: 1,
  DESIGNER_ASSIGNED: 2,
  DESIGNER_PICKED: 3,
  DESIGNER_FINISHED: 4,
  REJECTED: 5,
  FINAL: 6,
});

export const STATUS_META = {
  [CREATIVE_STATUS.DRAFT]: { label: "Draft", color: "bg-gray-100 text-gray-800" },
  [CREATIVE_STATUS.DESIGNER_ASSIGNED]: { label: "Designer Assigned", color: "bg-blue-100 text-blue-800" },
  [CREATIVE_STATUS.DESIGNER_PICKED]: { label: "Designer Picked", color: "bg-pending text-pending_text" },
  [CREATIVE_STATUS.DESIGNER_FINISHED]: { label: "Designer Finished", color: "bg-done text-done_text" },
  [CREATIVE_STATUS.REJECTED]: { label: "Rejected", color: "bg-reject text-reject_text" },
  [CREATIVE_STATUS.FINAL]: { label: "Final", color: "bg-client_approve text-client_approve_text" },
};

export const StatusChip = ({ status }) => {
  const meta = STATUS_META[status] || { label: "Unknown", color: "bg-gray-100 text-gray-800" };
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full font-medium whitespace-nowrap ${meta.color}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {meta.label}
    </span>
  );
};
